import React, { useCallback, useContext } from 'react';
import {
  MessageList,
  MessageInput,
  Window,
  useChannelStateContext,
  Thread,
} from 'stream-chat-react';
import type { LocalMessage, Message, SendMessageOptions } from 'stream-chat';

import { GiphyContext } from '../../SharedChat';
import { MessagingChannelHeader } from '../../components';

import { Utils } from '@utils';
import { NotificationService } from '@services';

export type ChannelInnerProps = {
  toggleMobile: () => void;
  theme: string;
};

export const ChannelInner: React.FC<ChannelInnerProps> = (props) => {
  const { theme, toggleMobile } = props;
  const { giphyState, setGiphyState } = useContext(GiphyContext);

  const { channel } = useChannelStateContext();

  const overrideSubmitHandler = useCallback(async ({
    message,
    sendOptions,
  }: {
    cid: string;
    localMessage: LocalMessage;
    message: Message;
    sendOptions: SendMessageOptions;
  }) => {
    let updatedText = message.text;

    if (message.attachments?.length && message.text?.startsWith('/giphy')) {
      updatedText = message.text.replace('/giphy', '');
    }

    if (giphyState) {
      updatedText = `/giphy ${message.text}`;
    }

    const finalMessage = updatedText !== message.text ? { ...message, text: updatedText } : message;

    await channel.sendMessage(finalMessage, sendOptions);

    // Send push notification
    const members = Utils.getChatMembers(channel);
    const mobileAppUser = Utils.getMobileAppUser(members);
    const garage = Utils.getGarage(members);

    const chatTitle = `${garage?.user?.name} sent you a message`;
    let chatMessage: string | undefined = '';

    if (finalMessage.attachments && finalMessage.attachments.length > 0) {
      chatMessage = `${garage?.user?.name} sent you an attachment`;
    } else {
      chatMessage = finalMessage?.text;
    }

    if (mobileAppUser?.user?.id && chatMessage) {
      await NotificationService.sendChatMessageNotification({
        userId: mobileAppUser.user.id,
        chatMessage: Utils.formatChatText(chatMessage) ?? '',
        chatTitle: chatTitle,
        chatChannel: channel.id ?? '',
      });
    }

    setGiphyState(false);
  }, [channel, giphyState, setGiphyState]);

  const actions = ['flag', 'mute', 'react', 'reply'];

  return (
    <>
      <Window>
        <MessagingChannelHeader theme={theme} toggleMobile={toggleMobile} />
        <MessageList messageActions={actions} />
        <MessageInput focus maxRows={8} overrideSubmitHandler={overrideSubmitHandler} />
      </Window>
      <Thread additionalMessageInputProps={{ maxRows: 8 }} />
    </>
  );
};
